import React, { Component } from "react";
import ReactQuill from "react-quill";
import styled from "styled-components";
import "react-quill/dist/quill.snow.css";
import "./QuillEditor.css";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

// html 태그 편집기능
let htmlTextArea = document.createElement("textarea");
let attrHtmlTextArea = document.createAttribute("quill__html");
htmlTextArea.setAttributeNode(attrHtmlTextArea);

function htmlEditor() {

  const activeTextArea =
    htmlTextArea.getAttribute("quill__html").indexOf("-active-") > -1;

  if (activeTextArea) {
    this.quill.pasteHTML(htmlTextArea.value);
    // this.quill.pasteHTML(`<p>메롱</p>`);
  } else {
    if (!this.quill.container.querySelector(".ql-custom")) {
      const quillCustomDiv = this.quill.addContainer("ql-custom");
      quillCustomDiv.appendChild(htmlTextArea);
    }
    const html = this.quill.container.querySelector(".ql-editor").innerHTML;
    htmlTextArea.value = html;
    // htmlTextArea.value = `<h1>메롱</h1>`;
  }
  htmlTextArea.setAttribute("quill__html", activeTextArea ? "" : "-active-");
}

export default
@inject("commonStore")
@withRouter
@observer
class QuillOne extends Component {
  // componentWillMount() {
  //   console.log("componentWillMount");
  // }

  componentDidUpdate() {
    if (htmlTextArea === null) {
      htmlTextArea = document.createElement("textarea");
    }
    if (attrHtmlTextArea === null) {
      attrHtmlTextArea = document.createAttribute("quill__html");
      htmlTextArea.setAttributeNode(attrHtmlTextArea);
    }

    for (let d of this.props.mainKw.current.value.split(" ")) {
      //띄어쓰기 해도 메인키워드 인식 할 수 있게 함
      if (this.props.contValue.split(d).length - 1 > 1) {
        this.props.commonStore.setTodo(1, 1); // 본문에 키워드가 2개 이상이면 할 일 목록 on
      } else {
        this.props.commonStore.setTodo(2, 1);
      }
    }

    if (this.props.contValue.split("<img").length - 1 > 1) {
      this.props.commonStore.setTodo(1, 2); // 이미지 2장 이상이면 할 일 목록 on
    } else {
      this.props.commonStore.setTodo(2, 2);
    }

    if (this.props.contValue.split("<a").length - 1 > 1) {
      this.props.commonStore.setTodo(1, 3); // 링크가 2개 이상이면 할 일 목록 on
    } else {
      this.props.commonStore.setTodo(2, 3);
    }

    if (this.props.commonStore.hTagCount > 1) {
      this.props.commonStore.setTodo(1, 4); // 소제목이 2개 이상이면 할 일 목록 on
    } else {
      this.props.commonStore.setTodo(2, 4);
    }

    if (this.props.quillRef.current.editingArea.textContent.length > 1499) {
      this.props.commonStore.setTodo(1, 5);
    } else {
      this.props.commonStore.setTodo(2, 5);
    }
  }

  componentWillUnmount() {
    // console.log("componentWillUnmount");
    attrHtmlTextArea = null;
    htmlTextArea = null;
  }

  modules = {
    toolbar: {
      container: [
        [{ header: [2, 3, 4] }],
        [
          "bold",
          "underline",
          "strike",
          "code-block",
          { color: [] },
          { background: [] },
          { size: ["small", false, "large", "huge"] },
        ],
        ["link", "image", "video"],
        [{ align: [] }],
        ["clean"], // 글자 기능 초기화
      ],
      handlers: {
        link: function (value) {
          if (value) {
            let href = prompt("Enter the URL");

            if (!href) {
              return;
            }

            if (
              !/http(s)?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi.test(
                href
              )
            ) {
              alert("주소 형식이 맞지 않습니다. 다시 설정해주세요.");
              return;
            }
            this.quill.format("link", href);
          } else {
            this.quill.format("link", false);
          }
        },
        "code-block": htmlEditor, //html 제어
      },
    },
    history: {
      //처음 ctrl + Z할 때 사라지는 거 방지
      delay: 2000,
      maxStack: 500,
      userOnly: true,
    },
  };

  formats = [
    "header",
    "bold",
    "underline",
    "strike",
    "color",
    "background",
    "size",
    "link",
    "image",
    "video",
    "align",
    "clean",
  ];

  render() {
    const checkLength = () => {
      //글자 수 세기 및 할 일 목록 체크
      this.props.setCount(this.props.quillRef.current.editingArea.textContent);
    };

    return (
      <Box>
        <span>본문</span>
        <div>
          {this.props.status === undefined ? ( //검수자 권한 글 작성 에러 방지
            <ReactQuill
              theme="snow"
              ref={this.props.quillRef}
              value={this.props.contValue}
              onChange={this.props.setContValue}
              modules={this.modules}
              formats={this.formats}
              onKeyUp={checkLength}
            />
          ) : (
            <ReactQuill
              theme="snow"
              ref={this.props.quillRef}
              value={this.props.contValue}
              onChange={this.props.setContValue}
              modules={this.modules}
              formats={this.formats}
              onKeyUp={checkLength}
              readOnly={
                this.props.status !== 2 &&
                parseInt(localStorage.getItem("writer_id")) === 224
                  ? false
                  : this.props.writerId !==
                      parseInt(localStorage.getItem("writer_id")) ||
                    this.props.status === 2 ||
                    this.props.status === 4
                  ? true
                  : false // 검수 전, 검수완료 상태일 때 수정불가
              }
            />
          )}
          <Err>{this.props.err.content}</Err>
        </div>
      </Box>
    );
  }
}

const Box = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;

  > span {
    margin-right: 75px;
  }
  > div {
    width: 85.5%;

    > .quill {
      width: 100%;
      height: 400px;
    }
  }
`;

const Err = styled.p`
  color: #f43419;
  line-height: 1.5;
  font-size: 14px;
  margin-top: 45px;
  margin-left: 3px;
`;
